import { useRouter } from "next/router";
import { useQueryClient } from "react-query";
import { deleteCookie, getCookies } from "cookies-next";
import { useSupabase } from "#next//hooks/use-supbase";
import { Logger } from "#/lib/logging";

export const useLogout = (): () => Promise<void> => {
  const supabase = useSupabase();
  const router = useRouter();
  const queryClient = useQueryClient();

  return async (): Promise<void> => {
    const cookies = getCookies();
    if (cookies) {
      Object.keys(cookies).forEach(cookie => deleteCookie(cookie));
    }
    await supabase.auth.signOut().catch(e => {
      Logger.error({
        message: "Error signing out",
        error: e
      });
    });
    queryClient.clear();
    await router.push("/");
    router.reload();
  };
};